import sanitizeHtml from 'sanitize-html';

// richText(Tiptap HTML)에서 폼 필드용 텍스트를 추출한다.
// 수식(math-inline)은 data-latex 를 ZWSP(U+200B)로 감싸 보존한다 — 이 값이
// prepareTiptapHTML 로 다시 들어갈 때(에디터 content 폴백·저장 후 재로딩) 무손실
// 왕복되도록 하기 위함이다. bare LaTeX(구분자 없음)로 뽑으면 parseMathContent 가
// 수식으로 인식하지 못해 리터럴로 깨진다. 수동 수식 에디터(EquationEditorModal)의
// ZWSP 감싸기와 동일 규칙이며, 서버 canonical(ZWSP) 저장과도 일치한다.
// 주의: 브라우저 환경에서만 작동하도록 함 (DOM API 사용)
export function extractBareText(htmlContent: string) {
  if (typeof window === 'undefined') return htmlContent;
  //span, p, math-inline 태그만 남기고 나머지 태그 모두 제거
  const textWithoutTagsExceptSpanAndP = sanitizeHtml(htmlContent, {
    allowedTags: ['span', 'p', 'br', 'math-inline'],
    allowedAttributes: {
      span: ['data-latex'],
      'math-inline': ['data-latex'],
    },
  });

  // 수식 데이터를 추출하기 위해 별도 처리
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = textWithoutTagsExceptSpanAndP;

  const latexSpans = tempDiv.querySelectorAll(
    'span[data-latex], math-inline[data-latex]',
  );
  const paragraphs = tempDiv.querySelectorAll('p');
  const lineBreaks = tempDiv.querySelectorAll('br');

  //모든 p 태그 앞에 \n 추가
  paragraphs.forEach((p, index) => {
    if (index > 0) {
      const textNode = document.createTextNode('\n');
      p.parentNode?.insertBefore(textNode, p);
    }
  });

  //모든 br 태그 앞에 \n 추가
  lineBreaks.forEach(br => {
    const textNode = document.createTextNode('\n');
    br.parentNode?.insertBefore(textNode, br);
  });

  //모든 span 태그 안의 수식을 추출해 ZWSP(U+200B)로 감싼 텍스트 노드로 변환
  //(prepareTiptapHTML 왕복 시 수식으로 재인식되도록 구분자를 보존한다)
  latexSpans.forEach(span => {
    const latexValue = span.getAttribute('data-latex');
    if (latexValue) {
      const textNode = document.createTextNode(`\u200B${latexValue}\u200B`);
      span.parentNode?.replaceChild(textNode, span);
    }
  });

  //남은 span, p 태그 전부 제거
  const finalSanitizedHtml = sanitizeHtml(tempDiv.outerHTML, {
    allowedTags: [],
    allowedAttributes: {},
  });

  return finalSanitizedHtml;
}
